/**
 * Parses the query params to get the manifest.
 * Expected format: ?mfe={"mfeName":"mfeUrl"}
 * mfeUrl can be one of:
 * 1. "local" to use portmapper url (https://events-manager-app.local.snap-dev.net:3001/remoteEntry.js)
 * 2. commit hash (https://release-manager-cdn.snap-dev.net/events-manager.12345678.remoteEntry.js)
 * 3. Full URL ("http/s" is not required)
 *
 * @returns {ModuleFederationManifest}
 */
export function getQueryParamsManifest(mfeJson?: string): Record<string, string> {
  if (!mfeJson) {
    return {};
  }

  let mfeObj: Record<string, string>;
  try {
    mfeObj = JSON.parse(mfeJson);
  } catch (e) {
    console.error('Error parsing mfe json', e);
    return {};
  }

  const SUFFIX = 'remoteEntry.js'; // this might change when we move to manifest.json

  return Object.entries(mfeObj).reduce<Record<string, string>>((acc, [mfeName, mfeValue]) => {
    if (/^[0-9a-fA-F]{7,40}$/.test(mfeValue)) {
      // commit hash mode
      acc[mfeName] = `https://release-manager-cdn.snap-dev.net/${mfeName}.${mfeValue.substring(0, 8)}.${SUFFIX}`;
    } else if (mfeValue === 'local') {
      // local mode
      acc[mfeName] = `https://${mfeName}-app.local.snap-dev.net:3001/${SUFFIX}`;
    } else {
      // full URL mode
      // ensure https prefix
      if (mfeValue.startsWith('https')) {
        // do nothing
      } else if (mfeValue.startsWith('http')) {
        mfeValue = mfeValue.replace('http', 'https');
      } else {
        mfeValue = `https://${mfeValue}`;
      }

      // ensure suffix
      if (!mfeValue.endsWith(SUFFIX)) {
        mfeValue = `${mfeValue}.${SUFFIX}`;
      }

      acc[mfeName] = mfeValue;
    }

    return acc;
  }, {});
}
